import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['evaluationComponent', 'comparisonOperator']);
  const modifyDiscountTrigger = `modifyDiscountTrigger(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyDiscountTrigger} {
      id
    }
  }
`;
};
